var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "station-edit-dialog",
      attrs: {
        "append-to-body": "",
        visible: _vm.innerVisible,
        title: _vm.$t("Warehouse.ContainerNo"),
        width: "450px",
        height: "300px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.innerVisible
        ? _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "128px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.PerContainerNo") } },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "228px" },
                        attrs: { disabled: "", no: "shipmentId" },
                        model: {
                          value: _vm.shipmentId,
                          callback: function($$v) {
                            _vm.shipmentId = $$v
                          },
                          expression: "shipmentId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.typeSummary
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.boxNum") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "228px" },
                            attrs: { disabled: "", no: "boxesNumber" },
                            model: {
                              value: _vm.boxesNumber,
                              callback: function($$v) {
                                _vm.boxesNumber = $$v
                              },
                              expression: "boxesNumber"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.boxSeq") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "80px", "margin-right": "8px" },
                          attrs: {
                            disabled: !_vm.typeSummary && !!_vm.containerSeq
                          },
                          model: {
                            value: _vm.boxSeqLen,
                            callback: function($$v) {
                              _vm.boxSeqLen = $$v
                            },
                            expression: "boxSeqLen"
                          }
                        },
                        _vm._l(_vm.types, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      ),
                      _c("el-input", {
                        staticStyle: { width: "50px", "margin-right": "8px" },
                        attrs: { no: "startSeq" },
                        on: { input: _vm.onInputStartSeq },
                        model: {
                          value: _vm.startSeq,
                          callback: function($$v) {
                            _vm.startSeq = $$v
                          },
                          expression: "startSeq"
                        }
                      }),
                      _vm.typeSummary
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "'Open Sans', Arial, sans-serif"
                              }
                            },
                            [_vm._v("——")]
                          )
                        : _vm._e(),
                      _vm.typeSummary
                        ? _c("el-input", {
                            staticStyle: {
                              width: "50px",
                              "margin-left": "8px"
                            },
                            attrs: { no: "endSeq", disabled: "" },
                            model: {
                              value: _vm.endSeq,
                              callback: function($$v) {
                                _vm.endSeq = $$v
                              },
                              expression: "endSeq"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "save" },
              on: { click: _vm.saveCallBack }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }